import { h, JSX } from 'preact';
import ObservingComponent from '../../../componentBases/observingComponent';
import Button from '../../../buttons/button';
import FormattedDate from '../../../text/formattedDate';
import { DateFormats, NamePlateReportPage as FrontEndNamePlateReportPage } from 'core.frontend';

export interface NamePlateReportPageProps {
    page: FrontEndNamePlateReportPage;
}

class NamePlateReportPage extends ObservingComponent<NamePlateReportPageProps> {

    public componentWillMount(): void {
        this.registerUpdateObserver(this.props.page.observationProvider);
    }

    public render({ page }: NamePlateReportPageProps): JSX.Element {
        return (
            <div className="report">
                <div className="flex">
                    <Button
                        className="mr-auto btn-icon"
                        button={page.backButton} />
                </div>

                <h3 className="text-center pl-1 pr-1 mt-1">
                    {!page.isLoading &&
                        <span>{page.reportData.eventName}</span>
                    }
                </h3>

                <div className="text-sm flex mb-1">
                    <div className="fill">
                        Printed by: {page.currentUsersName}
                        <div><b>{page.title}</b></div>
                    </div>
                    <div className="ml-2 text-right">

                        <FormattedDate
                            date={new Date()}
                            format={DateFormats.dddMMMMDhmmA} />

                        {!page.isLoading &&
                            <div>
                                <span>Total Rows: </span>
                                {page.reportData.reportDataItems.length}
                            </div>
                        }
                    </div>
                </div>

                {!page.isLoading && !!page.reportData.reportDataItems.length &&
                    <div className="report-page text-sm">

                        <table>
                            <thead>
                                <tr>
                                    <th className="text-center">Magnetic</th>
                                </tr>
                            </thead>
                            <tbody>
                                {page.reportData.reportDataItems?.filter(item => item.namePlateRequirements == 'Magnetic').map((item, index) =>
                                    <tr key={index}>
                                        <td className="text-center">{item.firstName} {item.lastName}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <table className="mt-2">
                            <thead>
                                <tr>
                                    <th className="text-center">Pocket Style</th>
                                </tr>
                            </thead>
                            <tbody>
                                {page.reportData.reportDataItems?.filter(item => item.namePlateRequirements == 'Pocket Style').map((item, index) =>
                                    <tr key={index}>
                                        <td className="text-center">{item.firstName} {item.lastName}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <table className="mt-2">
                            <thead>
                                <tr>
                                    <th className="text-center">None Required</th>
                                </tr>
                            </thead>
                            <tbody>
                                {page.reportData.reportDataItems?.filter(item => item.namePlateRequirements == 'None Required').map((item, index) =>
                                    <tr key={index}>
                                        <td className="text-center">{item.firstName} {item.lastName}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <table className="mt-2">
                            <thead>
                                <tr>
                                    <th className="text-center">Requirements Not Provided</th>
                                </tr>
                            </thead>
                            <tbody>
                                {page.reportData.reportDataItems?.filter(item => !['None Required', 'Magnetic', 'Pocket Style'].includes(item.namePlateRequirements)).map((item, index) =>
                                    <tr key={index}>
                                        <td className="text-center">{item.firstName} {item.lastName} {item.namePlateRequirements && <span> ({item.namePlateRequirements})</span>}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }

                {!page.isLoading && !page.reportData.reportDataItems.length &&
                    <div className="text-center mt-2">
                        <b>No information found</b>
                    </div>
                }

                {page.isLoading &&
                    <div className="text-center mt-2">
                        <b>Loading...</b>
                    </div>
                }
            </div>
        );
    }
}

export default NamePlateReportPage;